module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('router-link', {
    attrs: {
      "to": "/products-view"
    }
  }, [_c('p', {
    staticClass: "sg-top"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   " + _vm._s(this.$store.state.viewPDFName))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('iframe', {
    staticStyle: {
      "border": "1px solid #CCC",
      "border-width": "1px",
      "margin-bottom": "5px",
      "max-width": "100%",
      "height": "700px"
    },
    attrs: {
      "src": _vm.catalogueUrl,
      "width": "100%",
      "height": "650",
      "frameborder": "0",
      "marginwidth": "0",
      "marginheight": "0",
      "scrolling": "no",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sg-pname"
  }, [_vm._v(_vm._s(this.$store.state.viewPDFName))]), _vm._v(" "), _c('p', {
    staticClass: "sg-disco"
  }, [_vm._v(_vm._s(this.$store.state.viewPDFDescription))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ada73ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/SingleProductPdf.vue
// module id = 2098
// module chunks = 1